import { createInstance } from "@datapunt/matomo-tracker-react";
import config from "../config";

export const matomoInstance = createInstance({
	urlBase: config.analytics.urlBase,
	siteId: config.analytics.siteId,
	trackerUrl: config.analytics.trackerUrl,
	srcUrl: config.analytics.srcUrl,
	disabled: false,
	heartBeat: {
		active: true,
		seconds: 10,
	},
	linkTracking: true,
	configurations: {
		disableCookies: true,
		setSecureCookie: true,
		setRequestMethod: "POST",
	},
});
